import { Box, Button, Card, Container, Input, InputBase, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Popover, MenuItem, Select, TableHead, CircularProgress, DialogContentText, FormControl, InputLabel, OutlinedInput, Chip, Tabs, Tab, Grid } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Iconify from 'src/components/iconify';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getData, patchData, postData, putData, uploadFile } from 'src/webService/webService';
import { toast } from 'react-toastify';
import PaginationComponent from 'src/components/pagination';
import wordIcon from '../../components/logo/icons-word.png'
import pdfIcon from '../../components/logo/icons-pdf.png'
import { file_URL } from '../../utils/url'

function EditingTeam() {

  const [open, setOpen] = useState(null);
  const [editingTasks, setEditingTasks] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [dailyData, setDailyData] = useState("");
  const [editRow, setEditRow] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [updateLead, setUpdateLead] = useState();
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [view, setView] = useState([]);
  const [details, setDetails] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const descriptionElementRef = useRef(null);
  const [selectedLead, setSelectedLead] = useState("");
  const [scroll, setScroll] = useState('paper');
  const [allUpdates, setAllUpdates] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState({})
  const [fileUpload, setFileUpload] = useState(null);
  const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
  const [convertForm, setConvertForm] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [assignedLeads, setAssignedLeads] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [events, setEvents] = useState([]);
  const [graphicId, setGraphicId] = useState("");
  const [socialId, setSocialId] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [formData, setFormData] = useState({
    projectName: "",
    rawFootageUpload: "",
    editingType: "",
    editingSoftwareUsed: "",
    editingProgress: "",
    comments: "",
    deadline: "",
    teamCommunicationNotes: "",
    status: ""
  });

  const [convertData, setConvertData] = useState({
    // Common fields
    serviceName: "",
    assignedTo: [],
    employeeWork: {},
    noOfPosters: [],
    deadline: [],
    status: [],
    comments: "",
    paymentStatus: "",
    projectName: "",
    requirements: "",
    totalDesigns: "",
    platform: "",
    postType: "",
    contentTopic: "",
    postCaption: "",
    hashtagsUsed: "",
    scheduledDateTime: "",
    postedBy: "",
    postStatus: "",
    totalPosts: "",
    monthlyPosts: "",
    assignedPosts: "",
    assignedDesigns: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setConvertData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleServiceChange = (e) => {
    const { value } = e.target;
    setConvertData(prev => ({
      ...prev,
      serviceName: value
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleOpenMenu = (event, task, id, workUpdateId) => {
    debugger
    let lead;
    getLeadById(id)
    if (task && typeof task === 'object') {
      lead = task;
      setSelectedLead(lead);
    }
    else {
      lead = assignedLeads.find((data) => data._id === id);
      setSelectedLead(lead);
    }

    if (event?.currentTarget) {
      setOpen(event.currentTarget);
      setSelectedLeadId(id);
      setSelectedWorkUpdateId(workUpdateId);
      setView(task);
      console.log(view, "viewwwww")
      setSelectedLead(lead);
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleOpenDialog = async () => {
    await getAllUpdatesAdmin();
    setDetails(true);
    handleCloseMenu();
  };

  const handleCloseDialog = () => {
    setDetails(false);
  };

  const handleOpen = async () => {
    setFormOpen(true);
    handleCloseMenu();
  }

  const handleClose = () => {
    setFormOpen(false)
  }

  const handleFormOpen = async (leadId) => {
    setOpen(false);
    await getAllUsers();
    setSelectedLeadId(leadId);
    setConvertForm(true);
    setFormOpen(false);
  }

  const handleFormClose = () => {
    setConvertForm(false)
  }

  useEffect(() => {
    if (details) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [details]);

  const sessionToken = sessionStorage.getItem("Token");
  const role = sessionStorage.getItem("role");
  const roleType = sessionStorage.getItem("roleType");
  const serviceTeamType = sessionStorage.getItem("serviceTeamType");
  const UserId = sessionStorage.getItem('userId');

  const handleMultiSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setConvertData((prev) => ({
      ...prev,
      assignedTo: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const getAllUsers = async () => {
    try {
      const params = { page: 1, limit: 1000 };
      const response = await getData("users/users", params);
      console.log("Response:", response);

      let filteredUsers = [];

      if (role === "Admin") {
        filteredUsers = response.data.results.filter(user =>
          user.serviceTeamType &&
          (user.serviceTeamType.includes("Social Media") ||
            user.serviceTeamType.includes("Graphic Designing")) &&
          user.roleType === "Team Leader"
        );
      } else if (roleType === "Team Leader") {
        filteredUsers = response.data.results.filter(user =>
          user.serviceTeamType && user.serviceTeamType.includes("Video Editing")
        );
      }

      const formattedOptions = filteredUsers.map(user => ({
        id: user._id,
        name: user.name
      }));

      setEmployeeOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to load users");
    }
  };

  const convertLeads = async () => {
    debugger
    try {
      const sessionToken = sessionStorage.getItem("Token");
      if (!sessionToken) {
        toast.error("Authentication Error! Please login again.");
        return;
      }

      let payload;
      let endpoint;

      if (role === "Admin") {
        if (convertData.serviceName === "Graphic Designing") {
          payload = {
            serviceName: convertData.serviceName,
            projectName: convertData.projectName || "",
            requirements: convertData.requirements || "",
            assignedTo: convertData.assignedTo,
            deadline: convertData.deadline || "",
            assignedDesigns: convertData.assignedDesigns || "",
            totalDesigns: convertData.totalDesigns || "",
            comments: convertData.comments || "",
            paymentStatus: convertData.paymentStatus || "",
            leadId: selectedLeadId,
            userId: UserId
          };
          endpoint = `graphicdesign/graphicdesign/${graphicId}`;
        } else if (convertData.serviceName === "Social Media") {
          payload = {
            serviceName: convertData.serviceName,
            platform: convertData.platform || "",
            postType: convertData.postType || "",
            totalPosts: convertData.totalPosts || "",
            monthlyPosts: convertData.monthlyPosts || "",
            assignedPosts: convertData.assignedPosts || "",
            assignedTo: convertData.assignedTo,
            deadline: convertData.deadline || "",
            comments: convertData.comments || "",
            paymentStatus: convertData.paymentStatus || "",
            leadId: selectedLeadId,
            userId: UserId
          };
          endpoint = `socialmedia/socialmedia/${socialId}`;
        } else {
          throw new Error("Invalid service name");
        }

        const response = await patchData(endpoint, payload, sessionToken);
        if (response.status === 200) {
          toast.success("Service Assigned successfully!");
        } else {
          throw new Error(response.message || "Failed to assign Service");
        }
      } else if (roleType === "Team Leader") {
        const params = {
          serviceName: ["Video Editing"],
          assignedTo: convertData.assignedTo,
          employeeWork: convertData.employeeWork,
          serviceStatus: "In Progress",
          noOfPosters: convertData.noOfPosters,
          deadline: convertData.deadline,
          status: convertData.status,
          serviceStatus: "In Progress",
        };
        const putResponse = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);
        console.log("Put Response:", putResponse);
        if (putResponse.status === 200) {
          toast.success("Lead assigned successfully!");
        }
      }
      setConvertForm(false);
      await fetchAssignedLeads();
    } catch (error) {
      console.error("Error while assigning lead:", error);
      toast.error("Something went wrong while assigning the lead.");
    }
  };

  const fetchAssignedLeads = async () => {
    try {
      let response;
      let editingLeads = [];

      if (role === "Admin" || roleType === "Team Leader") {
        const params = { page: currentPage, limit: limit, serviceName: "Video Editing" }
        response = await getData("leads/services", params, sessionToken);
        editingLeads = response.data.results[0].paginatedResults;
        const totalRecords = response.data.results[0].totalCount;
        setTotalPages(response.data.results[0].totalPages);
        setTotalCount(totalRecords);
      } else if (roleType === "Employee") {
        const params = {
          page: currentPage,
          limit: limit
        };

        const endpoint = `leads/leads/${UserId}`;

        response = await getData(endpoint, params, sessionToken);

        if (roleType === "Employee" && response?.data) {
          const leadsData = Array.isArray(response.data)
            ? response.data[0]?.paginatedResults
            : response.data[0]?.paginatedResults || [];

          editingLeads = leadsData;

          const totalRecords = response.data[0].totalCount.totalItems ? response.data[0].totalCount.totalItems : 0;
          setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
          setTotalCount(totalRecords);
        }
      }

      setAssignedLeads(editingLeads);
      console.log("Video Editing", editingLeads);

      const latestDeadlines = {};
      editingLeads.forEach(lead => {
        const leadId = lead._id;
        const deadline = lead.videoEditingHistory?.deadline;
        if (deadline && (!latestDeadlines[leadId] ||
          new Date(deadline) > new Date(latestDeadlines[leadId].deadline))) {
          latestDeadlines[leadId] = lead;
        }
      });

      const latestDeadlinesArray = Object.values(latestDeadlines);

      const deadlineEvents = latestDeadlinesArray.map(lead => ({
        id: lead._id + '-deadline',
        title: `Deadline: ${lead.videoEditingHistory?.contentType || 'Content'}`,
        start: lead.videoEditingHistory?.deadline,
        allDay: true,
        extendedProps: {
          type: 'deadline',
          leadName: lead.name,
          contentType: lead.videoEditingHistory?.contentType,
          progress: lead.videoEditingHistory?.completionPercentage
            ? `${Math.round(lead.videoEditingHistory.completionPercentage)}%`
            : '0%'
        },
        backgroundColor: '#FF8A80',
        borderColor: '#FF8A80',
        textColor: '#000'
      }));

      setEvents(prevEvents => [...prevEvents, ...deadlineEvents]);

    } catch (err) {
      console.error("Error while fetching Video Editing Team:", err);
      toast.error("Failed to load Video Editing Team.");
    }
  };

  const getDailyUpdates = async () => {

    try {
      const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
      console.log("Response Daily Updates:", response)
      const results = response?.data;
      console.log("Results:", results)
      setDailyData(results);

    } catch (err) {
      console.error("Error while fetching Website Designing Team:", err);
      toast.error("Failed to load Website Designing Team.");
    }

  }

  const getAllUpdatesAdmin = async () => {

    const params = {
      page: 1,
      limit: 1000
    }

    try {
      const response = await getData("dailyworkupdates/updates", params, sessionToken);
      console.log("Response Dailyyy Updates:", response)

      const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Video Editing");

      console.log("Filtered Data:", filteredData);
      setAllUpdates(filteredData); // Store all data here
      // setView(filteredData);

    } catch (err) {
      console.error("Error while fetching Content Creation Team:", err);
      toast.error("Failed to load Content Creation Team.");
    }

  }

  const handleFileChange = (event, leadId) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
      handleFileUpload(file, leadId);
    }
  };

  const handleFileUpload = async (fileupload, leadId) => {
    console.log("Fileupload:", fileupload);
    console.log("Is File:", fileupload instanceof File);

    const formDataToSend = new FormData();
    formDataToSend.append("file", fileupload);

    try {
      const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
      if (response?.status === 200) {
        toast.success("File uploaded successfully!");
        setFileUpload(response?.data);
        setFormData(prevState => ({
          ...prevState,
          fileupload: response?.data,
        }));
      } else {
        toast.error("File upload failed!");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("Error uploading file.");
    }
  };

  const postDailyUpdates = async () => {
    debugger

    try {

      const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
      const existingUpdates = checkResponse?.data?.flatMap(update => update?.videoEditingHistory?.map(history => history?.dailyUpdateId));

      const videoEditingHistory = selectedLead?.videoEditingHistory?.[0] ||
        selectedLead?.videoEditingHistory ||
        {};
      const assignedEditingShots = selectedLead?.videoEditingHistory?.[0]?.assignedEditingShots;
      const previousCompleted = videoEditingHistory.completedEditingShots || 0;
      const newCompleted = parseInt(formData.completedEditingShots, 10) || 0;
      const totalCompleted = previousCompleted + newCompleted;
      const remainingShots = assignedEditingShots - newCompleted;

      const editingType = selectedLead?.videoEditingHistory?.[0]?.editingType ||
        selectedLead?.videoEditingHistory?.editingType ||
        '';

      const deadline = selectedLead?.videoEditingHistory?.[0]?.deadline ||
        selectedLead?.videoEditingHistory?.deadline ||
        '';

      const totalEditingShots = selectedLead?.videoEditingHistory?.[0]?.totalEditingShots ||
        selectedLead?.videoEditingHistory?.totalEditingShots;

      const amount = selectedLead?.videoEditingHistory?.[0]?.amount ||
        selectedLead?.videoEditingHistory?.amount ||
        '';
      const assignedTo = selectedLead?.videoEditingHistory?.[0]?.assignedTo ||
        selectedLead?.videoEditingHistory?.assignedTo ||
        '';
      const status = selectedLead?.videoEditingHistory?.[0]?.completedEditingShots === selectedLead?.videoEditingHistory?.[0]?.totalEditingShots ? "Completed" : "In Progress";

      const payLoad = {
        leadId: selectedLeadId,
        amount,
        assignedTo,
        editingType,
        comments: formData.comments,
        rawFootageUpload: fileUpload,
        serviceName: "Video Editing",
        deadline,
        totalEditingShots,
        completedEditingShots: totalCompleted,
        userId: UserId,
        status,
        assignedEditingShots: remainingShots
      }

      let response;

      if (existingUpdates.length === 0) {
        response = await postData('dailyworkupdates', payLoad, sessionToken);
      } else {
        const updateId = existingUpdates[existingUpdates.length - 1];
        response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
      }

      if (response?.status === 200) {
        toast.success("Daily Work Updated Successfully!");
        handleClose();
        getDailyUpdates();
        fetchAssignedLeads();
      } else {
        throw new Error(response?.message || "Failed to update Daily Work.");
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again!");
    }
  }

  const handleLimitChange = (event) => {
    setCurrentPage(1);
    if (currentPage === 1) {
      setLimit(event.target.value)
      fetchAssignedLeads(1, event.target.value)
    }
    else {
      setCurrentPage(1);
      setLimit(event.target.value);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      fetchAssignedLeads(currentPage - 1, limit);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      fetchAssignedLeads(currentPage + 1, limit);
    }
  };

  const calculateIndex = (index) => {
    return (currentPage - 1) * limit + index + 1;
  };

  useEffect(() => {
    getAllUsers();
    getAllUpdatesAdmin();
    fetchAssignedLeads(currentPage, limit);
    if (roleType === "Employee") {
      getDailyUpdates();
    }
  }, [role, roleType, serviceTeamType, currentPage, limit]);

  const getLeadById = async (id) => {
    try {
      const response = await getData(`leads/lead/${id}`, {}, sessionToken);
      if (response.status === 200) {
        const graphicDesigningHistory = response.data.graphicDesignHistory?.[0] || {};
        const socialMediaHistory = response.data.socialMediaHistory?.[0] || {};

        setGraphicId(graphicDesigningHistory._id || null);
        setSocialId(socialMediaHistory._id || null);

        const commonData = {
          assignedTo: graphicDesigningHistory.assignedTo || socialMediaHistory.assignedTo ?
            [graphicDesigningHistory.assignedTo || socialMediaHistory.assignedTo] : [],
          deadline: (graphicDesigningHistory.deadline || socialMediaHistory.deadline) ?
            (graphicDesigningHistory.deadline || socialMediaHistory.deadline).split('T')[0] : "",
          comments: graphicDesigningHistory.comments || socialMediaHistory.comments || "",
          paymentStatus: graphicDesigningHistory.paymentStatus || socialMediaHistory.paymentStatus || "",
        };

        if (convertData.serviceName === "Graphic Designing") {
          setConvertData(prev => ({
            ...prev,
            ...commonData,
            projectName: graphicDesigningHistory.projectName || "",
            requirements: graphicDesigningHistory.requirements || "",
            totalDesigns: graphicDesigningHistory.totalDesigns || "",
          }));
        } else if (convertData.serviceName === "Social Media") {
          setConvertData(prev => ({
            ...prev,
            ...commonData,
            platform: socialMediaHistory.platform?.[0] || "",
            postType: socialMediaHistory.postType?.[0] || "",
            totalPosts: socialMediaHistory.totalPosts || "",
            monthlyPosts: socialMediaHistory.monthlyPosts || "",
            assignedPosts: socialMediaHistory.assignedPosts || "",
          }));
        }
      }
    } catch (error) {
      console.error("Error while fetching lead details", error);
      // Consider adding error state or user notification
    }
  };

  return (
    <>
      <Helmet>
        <title>Service | Editing Team</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Editing Team
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "4px 12px",
                boxShadow: 1,
                marginRight: "20px"
              }}
            >
              <Iconify icon="eva:search-fill" />
              <InputBase
                placeholder="Search"
                sx={{ marginLeft: "8px" }}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
              {
                (role === "Admin" || roleType === "Team Leader") && (
                  <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    aria-label="content creation views"
                  >
                    <Tab label="Calendar View" />
                    <Tab label="Table View" />
                  </Tabs>
                )
              }
            </Box>
          </Box>
        </Stack>

        <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
          {
            (role === "Admin" || roleType === "Team Leader") && activeTab === 0 && (
              <Box sx={{ height: 500 }}>
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  headerToolbar={{
                    start: "",
                    center: 'prev title next',
                    end: ""
                  }}
                  events={events}
                  eventContent={renderEventContent}
                  height="100%"
                />
              </Box>
            )
          }
          {
            ((role === "Admin" || roleType === "Team Leader") && activeTab === 1) || roleType === "Employee" ? (
              <>
                <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                  {
                    role === "Admin" || roleType === "Team Leader" ? (
                      <Table>
                        <TableHead>
                          <TableCell>S.No</TableCell>
                          {/* <TableCell>Assigned User</TableCell> */}
                          <TableCell>Lead Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Phone</TableCell>
                          <TableCell>Project Name</TableCell>
                          <TableCell>Assigned Tasks</TableCell>
                          <TableCell>Completed Tasks</TableCell>
                          <TableCell>File</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell></TableCell>
                        </TableHead>
                        <TableBody>
                          {
                            assignedLeads.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={9} align="center">
                                  No data found
                                </TableCell>
                              </TableRow>
                            ) : (
                              assignedLeads?.map((task, id) => {
                                return (
                                  <TableRow key={task?.id}>
                                    <TableCell>{calculateIndex(id)}</TableCell>
                                    {/* <TableCell>{task?.assignedTo?.name || task.name}</TableCell> */}
                                    <TableCell>{task?.name}</TableCell>
                                    <TableCell>{task?.email}</TableCell>
                                    <TableCell>{task?.phone}</TableCell>
                                    <TableCell>{task?.videoEditingHistory?.projectName}</TableCell>
                                    <TableCell>{task?.videoEditingHistory?.assignedEditingShots ? task?.videoEditingHistory?.assignedEditingShots : "-"}</TableCell>
                                    <TableCell>{task?.videoEditingHistory?.completedEditingShots} / {task?.videoEditingHistory?.totalEditingShots}</TableCell>
                                    <TableCell>
                                      {
                                        task?.videoEditingHistory?.rawFootageUpload?.path ?
                                          <img
                                            src={task?.videoEditingHistory?.rawFootageUpload?.path
                                              ? `${file_URL + encodeURI(task?.videoEditingHistory?.rawFootageUpload?.path.replace("public/", ""))}`
                                              : "#"}
                                            alt='Image.png'
                                            style={{ maxWidth: "50px", cursor: "pointer" }}
                                            onClick={() => {
                                              const fullImage = task?.videoEditingHistory?.rawFootageUpload?.path
                                                ? `${file_URL + encodeURI(task?.videoEditingHistory?.rawFootageUpload?.path.replace("public/", ""))}`
                                                : "#";
                                              setSelectedImage(fullImage);
                                              setOpenImage(true);
                                            }}
                                          /> : "-"
                                      }
                                    </TableCell>
                                    <TableCell>
                                      <Box position="relative" display="inline-flex">
                                        <CircularProgress
                                          variant="determinate"
                                          value={task?.videoEditingHistory?.editingProgress}
                                        />
                                        <Box
                                          top={0}
                                          left={0}
                                          bottom={0}
                                          right={0}
                                          position="absolute"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                        >
                                          <Typography variant="caption" component="div" color="text.secondary">
                                            {`${Math.round(task?.videoEditingHistory?.editingProgress)}%`}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Iconify
                                        icon="material-symbols-light:more-vert"
                                        sx={{ margin: "auto" }}
                                        onClick={
                                          (event) => handleOpenMenu(event, task, task._id, task.videoEditingHistory?.dailyUpdateId)}
                                      />
                                    </TableCell>
                                  </TableRow>
                                )
                              })
                            )
                          }
                        </TableBody>
                      </Table>
                    ) : roleType === "Employee" ? (
                      <Table>
                        <TableHead>
                          <TableCell>S.No</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Contact</TableCell>
                          <TableCell>Assigned Work</TableCell>
                          <TableCell>Deadline</TableCell>
                          <TableCell>Completed Tasks</TableCell>
                          <TableCell>File</TableCell>
                          <TableCell>Progress</TableCell>
                          <TableCell></TableCell>
                        </TableHead>
                        <TableBody>
                          {
                            assignedLeads?.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={9} align="center">
                                  No data found
                                </TableCell>
                              </TableRow>
                            ) : (
                              assignedLeads?.map((work, id) => {
                                return (
                                  <TableRow key={work?.id}>
                                    <TableCell>{calculateIndex(id)}</TableCell>
                                    <TableCell>{work?.name}</TableCell>
                                    <TableCell>{work?.phone}</TableCell>
                                    <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                    <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                    <TableCell>{work?.videoEditingHistory[0]?.completedEditingShots} / {work?.videoEditingHistory[0]?.totalEditingShots}</TableCell>
                                    <TableCell>
                                      {work?.videoEditingHistory[0]?.rawFootageUpload?.path ?
                                        <img
                                          src={work?.videoEditingHistory[0]?.rawFootageUpload?.path
                                            ? `${file_URL + encodeURI(work?.videoEditingHistory[0]?.rawFootageUpload?.path.replace("public/", ""))}`
                                            : "#"}
                                          alt='Image.png'
                                          style={{ maxWidth: "50px", cursor: "pointer" }}
                                          onClick={() => {
                                            const fullImage = work?.videoEditingHistory[0]?.rawFootageUpload?.path
                                              ? `${file_URL + encodeURI(work?.videoEditingHistory[0]?.rawFootageUpload?.path.replace("public/", ""))}`
                                              : "#";
                                            setSelectedImage(fullImage);
                                            setOpenImage(true);
                                          }}
                                        />
                                        : "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                      <Box position="relative" display="inline-flex">
                                        <CircularProgress
                                          variant="determinate"
                                          value={work?.videoEditingHistory[0]?.progress}
                                        />
                                        <Box
                                          top={0}
                                          left={0}
                                          bottom={0}
                                          right={0}
                                          position="absolute"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                        >
                                          <Typography variant="caption" component="div" color="text.secondary">
                                            {typeof work?.videoEditingHistory[0]?.progress === 'number'
                                              ? `${Math.round(work.videoEditingHistory[0].progress)}%`
                                              : '0%'}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Iconify
                                        icon="material-symbols-light:more-vert"
                                        sx={{ margin: "auto" }}
                                        onClick={(event) => handleOpenMenu(event, work, work._id, work?.videoEditingHistory[0]?.dailyUpdateId)}
                                      />
                                    </TableCell>
                                  </TableRow>
                                )
                              })
                            )
                          }
                        </TableBody>
                      </Table>
                    ) : null
                  }
                </TableContainer>
                <PaginationComponent
                  name={"Leads"}
                  totalcount={totalCount}
                  limit={limit}
                  handleLimitChange={handleLimitChange}
                  handlePrevPage={handlePrevPage}
                  handleNextPage={handleNextPage}
                  currentPage={currentPage}
                  totalPages={totalPages}
                />
              </>
            ) : null
          }
        </Card>

        {/* Dialog for Adding Task */}
        <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
          <DialogTitle>Daily Work Update</DialogTitle>
          <DialogContent>
            <TextField
              name="completedEditingShots"
              label="Completed Tasks"
              type="number"
              fullWidth
              margin="dense"
              value={formData.completedEditingShots}
              onChange={handleChange}
            />
            {/* <TextField
              name="status"
              label="Status"
              fullWidth
              select
              margin="dense"
              value={formData.status}
              onChange={handleChange}
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="In Progress">In Progress</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
            </TextField> */}
            <TextField
              margin="dense"
              label="Comments"
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              margin='dense'
              type='file'
              hidden
              label="Upload File"
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handleFileChange(e)}
            >
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFormOpen(false)} color="secondary">Cancel</Button>
            <Button color="primary" onClick={postDailyUpdates}>Update</Button>
          </DialogActions>
        </Dialog>

        {/* Edit Menu  */}
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          }}
        >
          {
            role === "Admin" ? (
              <>
                <MenuItem onClick={handleOpenDialog}>
                  <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                  View
                </MenuItem>
                <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                  <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                  Assign To
                </MenuItem>
              </>
            ) : roleType === "Team Leader" ? (
              <>
                <MenuItem onClick={handleOpenDialog}>
                  <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                  View
                </MenuItem>
                <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                  <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                  Convert
                </MenuItem>
                {/* <MenuItem onClick={handleOpen}>
                  <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                  Work Update
                </MenuItem> */}
              </>
            ) : (
              <>
                <MenuItem onClick={handleOpenDialog}>
                  <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                  View
                </MenuItem>
                <MenuItem onClick={handleOpen}>
                  <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                  Work Update
                </MenuItem>
              </>
            )
          }
        </Popover>

        <Dialog
          open={details}
          onClose={handleCloseDialog}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
        >
          <DialogTitle id="scroll-dialog-title">
            <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
              Daily Work Updates
            </Typography>
          </DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              component="div" // Ensure DialogContentText renders as a div to contain Box/Grid
            >
              {!view || Object.keys(view).length === 0 ? (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant="h6" color="text.secondary">No data found</Typography>
                </Box>
              ) : (
                <Box sx={{ p: 1 }}>
                  <Paper elevation={3} sx={{
                    p: 2,
                    backgroundColor: '#ffffff',
                    borderRadius: 2,
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    borderLeft: '5px solid #1976d2' // A subtle accent line
                  }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="h6" sx={{ color: '#333' }}>
                          Project Details
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Name: {view?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Deadline: {new Date(view?.videoEditingHistory?.deadline).toLocaleDateString()}
                        </Typography>
                      </Grid>
                      {/* <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Status: <Typography component="span" sx={{
                            fontWeight: 'bold',
                            color: view?.videoEditingHistory?.status === 'Completed' ? 'success.main' :
                              view?.videoEditingHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                          }}>
                            {view?.videoEditingHistory?.status}
                          </Typography>
                        </Typography>
                      </Grid> */}
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Editing Software Used: {view?.videoEditingHistory?.editingSoftwareUsed}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Amount: {view?.videoEditingHistory?.amount}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Project Name: {view?.videoEditingHistory?.projectName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="h6" sx={{ color: '#333' }}>
                          Task Progress
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Completed Shots: {view?.videoEditingHistory?.completedShots}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Total Editing Shots: {view?.videoEditingHistory?.totalShots}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="body1">
                          Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                            {view?.videoEditingHistory?.editingProgress}%
                          </Typography>
                        </Typography>
                      </Grid>

                      {view?.[0]?.videoEditingHistory?.comments && (
                        <Grid item xs={12} id="paddingTop">
                          <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                            Comments
                          </Typography>
                          <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                            "{view?.[0]?.videoEditingHistory?.comments}"
                          </Typography>
                        </Grid>
                      )}

                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="h6" sx={{ color: '#333' }}>
                          Timestamps
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body2" color="text.secondary">
                          Created: {new Date(view?.createdAt).toLocaleString()}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body2" color="text.secondary">
                          Updated: {new Date(view?.updatedAt).toLocaleString()}
                        </Typography>
                      </Grid>
                    </Grid>
                    {
                      roleType === "Employee" && (
                        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                          <Table sx={{ minWidth: 350 }} aria-label="customized table">
                            <TableBody>
                              {/* Employee content history */}
                              {roleType === "Employee" && view?.contentCreationHistory?.length > 0 && (
                                <>
                                  {/* Title Row */}
                                  <TableRow>
                                    <TableCell
                                      colSpan={4}
                                      align="left"
                                      sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                    >
                                      Content Creation History
                                    </TableCell>
                                  </TableRow>

                                  {view.contentCreationHistory.map((history, hIndex) => {
                                    const filePath = history?.fileUpload?.path?.toLowerCase() || "";
                                    const fileUrl = history?.fileUpload?.path
                                      ? `${file_URL + encodeURI(
                                        history.fileUpload.path.replace("public/", "")
                                      )}`
                                      : null;

                                    return (
                                      <TableRow
                                        key={`content-${hIndex}`}
                                        hover
                                        onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                      >
                                        <TableCell align="center">{hIndex + 1}</TableCell>
                                        <TableCell align="center">
                                          {fileUrl ? (
                                            filePath.endsWith(".docx") ? (
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={wordIcon} alt="Word" height="40" width="40" />
                                              </a>
                                            ) : filePath.endsWith(".pdf") ? (
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                              </a>
                                            ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                              <img
                                                src={fileUrl}
                                                alt="Uploaded"
                                                style={{ maxWidth: "40px", cursor: "pointer" }}
                                              />
                                            ) : (
                                              <span style={{ fontSize: "18px" }}>-</span>
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </TableCell>
                                        <TableCell align="center">{history?.comments || "-"}</TableCell>
                                        <TableCell align="center">
                                          {history?.updatedAt
                                            ? new Date(history.updatedAt).toLocaleString()
                                            : "-"}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </>
                              )}

                              {/* Camera history */}
                              {roleType === "Employee" && view?.cameraHistory?.length > 0 && (
                                <>
                                  {/* Title Row */}
                                  <TableRow>
                                    <TableCell
                                      colSpan={4}
                                      align="left"
                                      sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                    >
                                      Camera History
                                    </TableCell>
                                  </TableRow>

                                  {view.cameraHistory.map((history, hIndex) => {
                                    const filePath = history?.fileUpload?.path?.toLowerCase() || "";
                                    const fileUrl = history?.fileUpload?.path
                                      ? `${file_URL + encodeURI(
                                        history.fileUpload.path.replace("public/", "")
                                      )}`
                                      : null;

                                    return (
                                      <TableRow
                                        key={`camera-${hIndex}`}
                                        hover
                                        onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                      >
                                        <TableCell align="center">{hIndex + 1}</TableCell>
                                        <TableCell align="center">
                                          {fileUrl ? (
                                            filePath.endsWith(".docx") ? (
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={wordIcon} alt="Word" height="40" width="40" />
                                              </a>
                                            ) : filePath.endsWith(".pdf") ? (
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                              </a>
                                            ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                              <img
                                                src={fileUrl}
                                                alt="Uploaded"
                                                style={{ maxWidth: "40px", cursor: "pointer" }}
                                              />
                                            ) : (
                                              <span style={{ fontSize: "18px" }}>-</span>
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </TableCell>
                                        <TableCell align="center">{history?.comments || "-"}</TableCell>
                                        <TableCell align="center">
                                          {history?.updatedAt
                                            ? new Date(history.updatedAt).toLocaleString()
                                            : "-"}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </>
                              )}

                              {/* Editing history */}
                              {roleType === "Employee" && view?.videoEditingHistory?.length > 0 && (
                                <>
                                  {/* Title Row */}
                                  <TableRow>
                                    <TableCell
                                      colSpan={4}
                                      align="left"
                                      sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                    >
                                      Video Editing History
                                    </TableCell>
                                  </TableRow>

                                  {view.videoEditingHistory.map((history, hIndex) => {
                                    const filePath = history?.rawFootageUpload?.path?.toLowerCase() || "";
                                    const fileUrl = history?.rawFootageUpload?.path
                                      ? `${file_URL + encodeURI(
                                        history.rawFootageUpload.path.replace("public/", "")
                                      )}`
                                      : null;

                                    return (
                                      <TableRow
                                        key={`editing-${hIndex}`}
                                        hover
                                        onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                      >
                                        <TableCell align="center">{hIndex + 1}</TableCell>
                                        <TableCell align="center">
                                          {fileUrl ? (
                                            filePath.endsWith(".docx") ? (
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={wordIcon} alt="Word" height="40" width="40" />
                                              </a>
                                            ) : filePath.endsWith(".pdf") ? (
                                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                              </a>
                                            ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                              <img
                                                src={fileUrl}
                                                alt="Uploaded"
                                                style={{ maxWidth: "40px", cursor: "pointer" }}
                                              />
                                            ) : (
                                              <span style={{ fontSize: "18px" }}>-</span>
                                            )
                                          ) : (
                                            "-"
                                          )}
                                        </TableCell>
                                        <TableCell align="center">{history?.comments || "-"}</TableCell>
                                        <TableCell align="center">
                                          {history?.updatedAt
                                            ? new Date(history.updatedAt).toLocaleString()
                                            : "-"}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )
                    }
                  </Paper>
                </Box>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
          <Iconify
            icon="material-symbols:close"
            onClick={() => setOpenImage(false)}
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              fontSize: 24,
              cursor: 'pointer',
              zIndex: 1
            }}
          />
          <DialogContent>
            <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
          </DialogContent>
        </Dialog>

        {/* Convert leads */}
        <Dialog open={convertForm}>
          <DialogTitle>Convert Leads</DialogTitle>
          <DialogContent>
            {role === "Admin" ? (
              <>
                <TextField
                  name="serviceName"
                  label="Service Name"
                  fullWidth
                  select
                  margin="dense"
                  value={convertData.serviceName}
                  onChange={handleInputChange}
                  required
                >
                  <MenuItem value="Graphic Designing">Graphic Designing</MenuItem>
                  <MenuItem value="Social Media">Social Media</MenuItem>
                </TextField>
                {
                  convertData.serviceName === "Graphic Designing" ? (
                    <>
                      <TextField margin="dense" label="Project Name" name="projectName" value={convertData.projectName || ''} onChange={handleInputChange} fullWidth />
                      <TextField margin="dense" label="Requirements" name="requirements" value={convertData.requirements || ''} onChange={handleInputChange} fullWidth />
                      <TextField
                        name="assignedTo"
                        label="Assigned To"
                        fullWidth
                        select
                        margin="dense"
                        value={convertData.assignedTo}
                        onChange={handleInputChange}
                        required
                      >
                        {employeeOptions.map((employee) => (
                          <MenuItem key={employee.id} value={employee.id}>
                            {employee.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField margin="dense" label="Deadline" name="deadline" type="date" InputLabelProps={{ shrink: true }} value={convertData.deadline || ''} onChange={handleInputChange} fullWidth />
                      <div style={{ display: "flex", justifyContent: "flex-start" }}>
                        <Typography variant="body1" style={{ margin: "5px 0px 0px 10px" }} gutterBottom>
                          Total Shots: {convertData.totalEditingShots ? convertData.totalEditingShots : "-"}
                        </Typography>
                        <Typography
                          variant="body1"
                          style={{ margin: "5px 0px 0px 10px" }}
                          gutterBottom
                        >
                          Pending Shots: {view?.videoEditingHistory?.totalEditingShots - view?.videoEditingHistory?.completedEditingShots}
                        </Typography>
                      </div>
                      <TextField
                        margin="dense"
                        label="Designs to Assign"
                        name="assignedDesigns"
                        type="number"
                        required
                        value={convertData.assignedDesigns || ''}
                        onChange={handleInputChange}
                        fullWidth
                      />
                      <TextField margin="dense" label="Comments" name="comments" value={convertData.comments || ''} onChange={handleInputChange} fullWidth />
                      <TextField margin="dense" select label="Payment Status" name="paymentStatus" value={convertData.paymentStatus || ''} onChange={handleInputChange} fullWidth>
                        {["Pending", "Completed"].map(p => (
                          <MenuItem key={p} value={p}>{p}</MenuItem>
                        ))}
                      </TextField>
                    </>
                  ) : convertData.serviceName === "Social Media" ? (
                    <>
                      <TextField
                        name="platform"
                        label="Platform"
                        fullWidth
                        select
                        margin="dense"
                        value={convertData.platform}
                        onChange={handleInputChange}
                        required
                      >
                        <MenuItem value="Facebook">Facebook</MenuItem>
                        <MenuItem value="Instagram">Instagram</MenuItem>
                        <MenuItem value="Twitter">Twitter</MenuItem>
                        <MenuItem value="LinkedIn">LinkedIn</MenuItem>
                        <MenuItem value="YouTube">YouTube</MenuItem>
                        <MenuItem value="TikTok">TikTok</MenuItem>
                      </TextField>
                      <TextField
                        name="postType"
                        label="Post Type"
                        fullWidth
                        select
                        margin="dense"
                        value={convertData.postType}
                        onChange={handleInputChange}
                        required
                      >
                        <MenuItem value="Image">Image</MenuItem>
                        <MenuItem value="Video">Video</MenuItem>
                        <MenuItem value="Text">Text</MenuItem>
                        <MenuItem value="Story">Story</MenuItem>
                        <MenuItem value="Reel">Reel</MenuItem>
                        <MenuItem value="Ad">Ad</MenuItem>
                      </TextField>
                      {/* <TextField
                        margin="dense"
                        label="Total Posts"
                        name="totalPosts"
                        type="number"
                        required
                        value={convertData.totalPosts || ''}
                        onChange={handleInputChange}
                        fullWidth
                      /> */}
                      <div style={{ display: "flex", justifyContent: "flex-start" }}>
                        <Typography variant="body1" style={{ margin: "5px 0px 0px 10px" }} gutterBottom>
                          Total Shots: {convertData.totalPosts ? convertData.totalPosts : "-"}
                        </Typography>
                        <Typography variant="body1" style={{ margin: "5px 0px 0px 10px" }} gutterBottom>
                          No of Reels / Months: {convertData.monthlyPosts ? convertData.monthlyPosts : "-"}
                        </Typography>
                        <Typography
                          variant="body1"
                          style={{ margin: "5px 0px 0px 10px" }}
                          gutterBottom
                        >
                          Pending Shots: {view?.videoEditingHistory?.totalEditingShots - view?.videoEditingHistory?.completedEditingShots}
                        </Typography>
                      </div>
                      <TextField
                        margin="dense"
                        label="Posts to Assign"
                        name="assignedPosts"
                        type="number"
                        required
                        value={convertData.assignedPosts || ''}
                        onChange={handleInputChange}
                        fullWidth
                      />
                      <TextField
                        name="assignedTo"
                        label="Assigned To"
                        fullWidth
                        select
                        margin="dense"
                        value={convertData.assignedTo}
                        onChange={handleInputChange}
                        required
                      >
                        {employeeOptions.map((employee) => (
                          <MenuItem key={employee.id} value={employee.id}>
                            {employee.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        name="deadline"
                        label="Deadline"
                        type="date"
                        fullWidth
                        margin="dense"
                        InputLabelProps={{ shrink: true }}
                        value={convertData.deadline}
                        onChange={handleInputChange}
                        required
                      />
                      <TextField
                        name="comments"
                        label="Additional Comments"
                        fullWidth
                        multiline
                        rows={3}
                        margin="dense"
                        value={convertData.comments}
                        onChange={handleInputChange}
                      />
                      <TextField required margin="dense" select label="Payment Status" name="paymentStatus" value={convertData.paymentStatus || ''} onChange={handleInputChange} fullWidth>
                        {["Pending", "Completed"].map(p => (
                          <MenuItem key={p} value={p}>{p}</MenuItem>
                        ))}
                      </TextField>
                    </>
                  ) : null
                }
              </>
            ) : roleType === "Team Leader" ? (
              <>
                <FormControl fullWidth margin="dense">
                  <InputLabel id="assign-to-label">Assign To</InputLabel>
                  <Select
                    labelId="assign-to-label"
                    multiple
                    value={convertData.assignedTo}
                    onChange={handleMultiSelectChange}
                    InputLabelProps={{ shrink: true }}
                    label="Assign To"
                    input={<OutlinedInput label="Assign To" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => {
                          const employee = employeeOptions.find(emp => emp.id === value);
                          return employee ? (
                            <Chip key={value} label={employee.name} />
                          ) : null;
                        })}
                      </Box>
                    )}
                    fullWidth
                  >
                    {employeeOptions.map((emp) => (
                      <MenuItem key={emp.id} value={emp.id}>
                        {emp.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box sx={{ mt: 2 }}>
                  {convertData.assignedTo.map((empId) => {
                    const employee = employeeOptions.find(emp => emp.id === empId);
                    return (
                      <>
                        <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                          <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                            <div className='col' style={{ marginTop: "5px" }}>
                              <Typography>{employee?.name}</Typography>
                            </div>
                          </div>
                        </Box>
                        <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                          <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                            <TextField
                              label="No of Posters"
                              value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                              onChange={(e) => {
                                const work = e.target.value;
                                setConvertData(prev => ({
                                  ...prev,
                                  employeeWork: {
                                    ...prev.employeeWork,
                                    [empId]: {
                                      ...prev.employeeWork?.[empId],
                                      noOfPosters: work
                                    }
                                  }
                                }));
                              }}
                              size="small"
                              fullWidth
                            />
                            <TextField
                              label="Deadline"
                              value={convertData.employeeWork?.[empId]?.deadline || ""}
                              onChange={(e) => {
                                const work = e.target.value;
                                setConvertData(prev => ({
                                  ...prev,
                                  employeeWork: {
                                    ...prev.employeeWork,
                                    [empId]: {
                                      ...prev.employeeWork?.[empId],
                                      deadline: work
                                    }
                                  }
                                }));
                              }}
                              type='date'
                              size="small"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                            />
                          </div>
                        </Box>
                      </>
                    );
                  })}
                </Box>
              </>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFormClose} color="secondary">Cancel</Button>
            <Button onClick={convertLeads} color="primary">Submit</Button>
          </DialogActions>
        </Dialog>

      </Container >
    </>
  );
}

function renderEventContent(eventInfo) {
  const isDeadline = eventInfo.event.extendedProps.type === 'deadline';
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: isDeadline ? '#FFEBEE' : '#F5F5F5',
      borderRadius: '8px',
      padding: '6px',
      marginTop: '5px',
      boxShadow: 2,
      fontSize: '12px',
      color: 'black',
      maxWidth: "125px",
      borderLeft: `4px solid ${eventInfo.event.backgroundColor || '#90CAF9'}`
    }}>
      <Box sx={{
        borderLeft: `4px solid ${eventInfo.event.extendedProps.color || '#90CAF9'}`,
        paddingLeft: '6px'
      }}>
        {isDeadline ? (
          <>
            <strong>⏰</strong>
            <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
            <div>Progress: {eventInfo.event.extendedProps.progress}</div>
          </>
        ) : (
          <>
            <strong>📝 {eventInfo.event.title}</strong>
            <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
            <div>Req: {eventInfo.event.extendedProps.requirement}</div>
            <div>Status: {eventInfo.event.extendedProps.status}</div>
            <div>Progress: {eventInfo.event.extendedProps.progress}</div>
          </>
        )}
      </Box>
    </Box>
  );
}

export default EditingTeam;